import * as R from "ramda";
import { validateObject, validateField } from "util/validation";
import { notBlank } from "../../util/ext";
import { curry } from "ramda";

const convertToModuleConstraints = {
  name: {
    presence: { allowEmpty: false, message: "^Title must not be blank" },
    length: { maximum: 255, message: "^Title cannot exceed 255 characters" },
  },
  displayName: {
    presence: { allowEmpty: false, message: "^Display Name must not be blank" },
    length: {
      maximum: 100,
      message: "^Display Name cannot exceed 100 characters",
    },
  },
  descriptionText: {
    presence: { allowEmpty: false, message: "^Description must not be blank" },
    length: {
      maximum: 4096,
      message: "^Description cannot exceed 4096 characters",
    },
  },
};

export const validateConvertToModuleField = (field, value, errors = {}) =>
  validateField(convertToModuleConstraints, field, value, errors);

export const validateConvertToModule = R.partial(validateObject, [
  convertToModuleConstraints,
]);

export const hasError = curry((errors, field) => notBlank(errors[field]));

export const firstError = curry((errors, field) =>
  errors[field] ? errors[field][0] : "",
);
